import { render, staticRenderFns } from "./Data2023.vue?vue&type=template&id=479897f9&"
import script from "./Data2023.vue?vue&type=script&lang=ts&"
export * from "./Data2023.vue?vue&type=script&lang=ts&"
import style0 from "./Data2023.vue?vue&type=style&index=0&id=479897f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports